import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom';

const FamilyPlazaTopSection = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const handleTabClick = (tabName) => {
        // Handle tab navigation
        navigate(`/${tabName}`);
    };


    return (
        <>

            {/* Hero Section */}
            <section className="hero-section">
                <div className="hero-image hero-background">
                    <div className="hero-overlay">
                        <div className="hero-content">
                            <div className="hero-yellow-line"></div>
                            <h1 className="hero-title">유족광장</h1>
                        </div>
                    </div>
                </div>
            </section>


            {/* Sub Navigation */}
            <section className="sub-navigation">
                <div className="tab-container">
                    <a
                        className={`tab-link ${location.pathname.includes('cyber-memorial-search') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('cyber-memorial-search');
                        }}
                    >
                        사이버추모관
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('letter-to-heaven-board-list') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('letter-to-heaven-board-list');
                        }}
                    >
                        하늘로 보내는 편지
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('management-fee-payment-inquiry') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('management-fee-payment-inquiry');
                        }}
                    >
                        관리비 납부 조회
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('ancestral-tablet') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('ancestral-tablet');
                        }}
                    >
                        지방출력
                    </a>
                </div>
            </section>

        </>
    )
}

export default FamilyPlazaTopSection;
